import { Flex, Grid, Image, Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'
// import webPhoneKeypadImageSmall from '~/assets/web-phone-call-screen-small.png'
import webPhoneKeypadImage from '~/assets/web-phone-call-screen.png'
import { useModalState } from '~/atoms/ModalState'
import { useUserState } from '~/atoms/UserState'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { DropdownMangoButton } from '~/components/shared/Dropdown/DropdownMangoButton'
import { MenuPlacement } from '~/components/shared/Dropdown/Menu'
import { MenuItem, MenuListItem } from '~/components/shared/Dropdown/MenuItem'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { useAnalytics } from '~/hooks/useAnalytics'
import { AnalyticsNamespace, WebPhoneAnalyticsEvents } from '~/types/Analytics'

import { ExtensionInstance } from '@mangovoice/types'

import { useOnboardingStyle } from './componentStyles/Onboarding.style'

interface OnboardingViewProps {
  onActivateButtonClick: () => void
}
export const OnboardingView = ({
  onActivateButtonClick,
}: OnboardingViewProps) => {
  const handleWebPhoneActivate = () => {
    onActivateButtonClick()
  }
  const { track } = useAnalytics(AnalyticsNamespace.WEB_PHONE)
  const { pbxExtensions, setCurrentUserExtension, pbx } = useUserState()
  const {
    confirmModal: [, setConfirmModalState],
  } = useModalState()
  const styles = useOnboardingStyle()

  // TODO the ext related stuff can probably be a separate component. settings needs the same functionality
  const extItems = useMemo(() => {
    return (
      pbxExtensions?.map((ext) => {
        return {
          value: ext,
          content: (
            <MenuListItem
              primaryText={ext.name}
              rightContent={<ExtensionBadge extension={ext.number} />}
            />
          ),
          onSelect: (ext: ExtensionInstance) => {
            track(WebPhoneAnalyticsEvents.ExtSelected)
            setCurrentUserExtension(pbx?.id, ext)
            handleWebPhoneActivate()
          },
        } as MenuItem<ExtensionInstance>
      }) ?? []
    )
  }, [pbxExtensions])

  const checkCanActivatePhone = () => {
    if (pbxExtensions?.length === 1) {
      setCurrentUserExtension(pbx?.id, pbxExtensions[0])
      handleWebPhoneActivate()
    } else if (pbxExtensions?.length === 0) {
      setConfirmModalState({
        title: `No Line Extensions Available`,
        message: (
          <Flex
            sx={{
              flexDirection: 'column',
              gap: '1.5rem',
            }}
          >
            <Text sx={{ fontSize: '1rem', fontWeight: '400' }}>
              You do not have any line extensions assigned on this phone system
              ({pbx?.name}).
            </Text>
            <Text sx={{ fontSize: '1rem', fontWeight: '400' }}>
              To use the phone feature, please contact your system administrator
              to assign a line extension.
            </Text>
          </Flex>
        ),
        confirmText: 'Dismiss',
        closeAfterConfirm: true,
        isDestructive: false,
      })
    }
  }

  return (
    <Grid sx={styles.content}>
      <Flex sx={styles.features}>
        <Image sx={styles.image} src={webPhoneKeypadImage} />
        <Text sx={styles.welcomeText}>Make Calls From Any Browser</Text>
        <Text sx={styles.bodyText}>
          Make & receive calls, transfer or park with ease, manage multiple
          calls, add favorites & speed dials. Your communication, your way, from
          anywhere.
        </Text>
        <Flex>
          <DropdownMangoButton
            variant={MangoButtonVariant.Default_300}
            items={extItems.length > 1 ? extItems : []}
            label="Activate Phone"
            onButtonClick={checkCanActivatePhone}
            menuOptions={{
              placement: MenuPlacement.BottomCenter,
              width: '23.9375rem',
            }}
          ></DropdownMangoButton>
        </Flex>
      </Flex>
    </Grid>
  )
}
